<template>
  <v-container>

    <v-row>
      <v-col md="12">
        <h1 class="font-weight-medium">{{ $t('Eventos DO Cava') }}</h1>
      </v-col>
    </v-row>

    <v-row>


      <v-col md="4">
        <v-text-field
            :label="$t('Nombre del evento')"
            filled
            v-model="text"
            maxlength="250"
        ></v-text-field>
      </v-col>
      <v-col md="2" style="padding-top:20px">
        <v-btn large color="primary" dark @click="search">
          {{ $t('buscar') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">{{ $t('Nombre del evento') }}</th>
              <th class="text-left">{{ $t('Descripción') }}</th>
<!--              <th class="text-left">{{ $t('País') }}</th>-->
              <th class="text-left"></th>
              <th class="text-left">{{ $t('Fecha límite de inscripción') }}</th>
              <th class="text-left"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.name">
              <td>
                <router-link :to="{name:'eventosedit', params:{id: item.uuid}}">
                  <span v-if="$i18n.locale=='es'">{{ item.evento.nombre_es }}</span>
                <span v-else>{{ item.evento.nombre_ca }}</span>
                </router-link>

              </td>
              <td>
                <span v-if="$i18n.locale=='es'">{{ item.evento.descripcion_breve_es }} </span>
                <span v-else>{{ item.evento.descripcion_breve_ca }} </span>
              </td>
              <td>
<!--                {{ item.evento.published_on.substring(0, 10) }}-->
              </td>

<!--              <td></td>-->
              <td>{{ item.evento.fecha_limite }}</td>
              <td>

                <v-btn v-if="item.evento.state==-1" :to="{name:'eventosedit', params:{id: item.uuid}}"
                       color="orange" class="white--text" small>
                  {{ $t('Cancelado') }}
                </v-btn>
                <v-btn v-else-if="item.ok" :to="{name:'eventosedit', params:{id: item.uuid}}" color="secondary"
                       class="white--text" small>
                  {{ $t('Inscrito') }}
                </v-btn>
                <v-btn v-else-if="exp(item.evento.fecha_limite) === true" :to="{name:'eventosedit', params:{id: item.uuid}}"
                       color="error" class="white--text" small>
                  {{ $t('Finalizado') }}
                </v-btn>
                <v-btn v-else :to="{name:'eventosedit', params:{id: item.uuid}}" color="primary" dark small>
                  {{ $t('Realizar Inscripción') }}
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-pagination
          v-model="page"
          :length="length"
          :page="page"
          total-visible="5"
      ></v-pagination>
    </v-row>
  </v-container>
</template>


<script>

import axios from "axios"
import 'url-search-params-polyfill';


export default {
  data() {
    return {
      page: 1,
      text: "",
      length: 6,
      data: []
    };
  },
  computed: {
    isavailable() {
      let d = new Date();

    }
  },
  methods: {
    exp(d) {
      let now = new Date()
      let today = now.setHours(0,0,0,0)//.getTime();
      let ev = new Date(d).getTime()
      if (  today > ev) {
        return true
      }
      console.log(ev, today)
      return false
    },
    df(d) {
      let current_datetime = new Date(d)
      return current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate()
    },
    search() {
      let data = {};
      if (this.text != "") {
        data.search = this.text
        this.page = 1
      }
      data.page = this.page
      const searchParams = new URLSearchParams(data);

      const jwt = this.$store.state.jwt
      const config = {
        headers: {Authorization: "Bearer " + jwt},
        params: searchParams,
        data: data
      };
      return axios.get(this.$store.state.endpoints.participacion + "myevents/", config)
          .then((response) => {
            console.log(response.data.results)
            this.data = response.data.results
            this.length = Math.ceil(response.data.count / 10)
          })
          .catch((error) => {
            console.error(error)
          })
    },
  },
  watch: {
    // whenever question changes, this function will run
    page: function (newQuestion, oldQuestion) {
      this.search()
    }
  },
  mounted() {
    this.search()
  }

};
</script>

<style>
.disable-events {
  pointer-events: none
}

</style>





